export default __webpack_public_path__ + "db87cbfc1e2997f09abb7a63d4e75520.svg";